import { combineReducers } from 'redux';
import subscriptionList from './subscriptionList'
import subscribedList from './subscribedList'

export default combineReducers({
    subscriptionList,
    subscribedList
});